import { FirstSectionAccount } from "./components/firstSection";


export const AccountPage = () => {
    return (
        <>
            <FirstSectionAccount/>
        </>
    );
};

